import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Text, Phone, NMLS, Email } from '../../..'
import {
  selectCustomerEmail,
  selectCustomerNMLS,
  selectCustomerPhone
} from '../../../../store/selectors/customerProfile'
import styles from './ContactInfo.module.scss'

const ContactInfo = () => {
  const customerEmail = useSelector(selectCustomerEmail)
  const customerPhone = useSelector(selectCustomerPhone)
  const customerNmls = useSelector(selectCustomerNMLS)

  return (
    <>
      {customerPhone && (
        <div className={styles.labelDataPair}>
          <Text size='xs' weight='semibold' variant='neutralCool' variantCount='700'>
            <FormattedMessage id='AgentDropdown.phone' defaultMessage='Phone' />
          </Text>
          <Text size='xs'>
            <Phone value={customerPhone} className={styles.customerPhone} />
          </Text>
        </div>
      )}
      {customerEmail && (
        <div className={styles.labelDataPair}>
          <Text variant='neutralCool' variantCount='700' size='xs' weight='semibold'>
            <FormattedMessage id='AgentDropdown.email' defaultMessage='Email' />
          </Text>
          <Text size='xs'>
            <Email value={customerEmail} className={styles.customerEmail} />
          </Text>
        </div>
      )}
      {customerNmls && (
        <Text variant='neutralCool' variantCount='700' size='tiny' className={styles.nmls}>
          <NMLS value={customerNmls} variant='neutralCool' variantCount='700' />
        </Text>
      )}
    </>
  )
}

export default ContactInfo
